import React, { useContext } from "react";
import ThemeContext from "../contexts/ThemeContext";
import { Snowflake } from "@phosphor-icons/react";
import Tippy from "@tippyjs/react";

const ChristmasToggle = () => {
    const { isChristmasTheme, toggleChristmasTheme } = useContext(ThemeContext);

    const tooltipContent = (
        <span style={{
            background: "var(--black-100)",
            color: "var(--white-100)",
            padding: "0.375rem 0.625rem",
            borderRadius: "0.375rem",
            fontSize: "0.8125rem",
            display: "block"
        }}>
            {isChristmasTheme ? "Désactiver le thème de Noël" : "Activer le thème de Noël"}
        </span>
    );

    return (
        <Tippy content={tooltipContent} placement="bottom" animation="scale-subtle" duration={[200, 150]}>
            <button
                onClick={toggleChristmasTheme}
                className="action-button"
                aria-label="Toggle Christmas Theme"
                style={{
                    width: "2.5rem",
                    height: "2.5rem",
                    flexShrink: 0,
                    borderRadius: "0.625rem",
                    border: "1px solid var(--black-15)",
                    background: isChristmasTheme ? "var(--red-50)" : "var(--white-100)",
                    color: isChristmasTheme ? "var(--red-500)" : "var(--black-60)",
                    cursor: "pointer",
                }}
            >
                <Snowflake size={18} weight="fill" />
            </button>
        </Tippy>
    );
};

export default ChristmasToggle;
